module.exports = __webpack_public_path__ + "static/img/call-pass-off.2e4a2ce3.png";